export type BuiltInUserTextFieldKey = 'firstName' | 'lastName' | 'email';

export const BUILTIN_USER_TEXT_FIELDS: Record<
    BuiltInUserTextFieldKey,
    { id: string; attributeName: string; translationKey: string }
> = {
    firstName: {
        id: 'firstName',
        attributeName: 'firstName',
        translationKey: 'GENERAL.PROPERTY.FIRST_NAME',
    },
    lastName: {
        id: 'lastName',
        attributeName: 'lastName',
        translationKey: 'GENERAL.PROPERTY.LAST_NAME',
    },
    email: {
        id: 'email',
        attributeName: 'email',
        translationKey: 'GENERAL.PROPERTY.EMAIL',
    },
};
